import { cn } from 'components/UI/cn'

interface ActionButtonProps {
  children: React.ReactNode
  onClick?: () => void
  disabled?: boolean
  className?: string
}

export function ActionButton({
  children,
  onClick,
  disabled = false,
  className = '',
}: ActionButtonProps) {
  return (
    <button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={cn(
        'inline-flex items-center justify-center py-1.5 px-3 rounded-md border border-new-company-gray-border font-medium text-xs transition-colors duration-150 focus:outline-none',
        'bg-white',
        {
          'text-new-company-gray-inactive cursor-not-allowed': disabled,
          // Using !important on hover/active backgrounds to override conflicting CSS specificity
          // issues that prevent normal Tailwind hover/active states from working properly
          'text-new-company-green-active cursor-pointer hover:!bg-new-company-pistachio-light hover:text-new-company-green-dark active:!bg-new-company-pistachio-medium active:text-new-company-green-dark':
            !disabled,
        },
        className
      )}
    >
      {children}
    </button>
  )
}
